import { createApp, defineAsyncComponent } from 'vue';
import { createHead } from '@vueuse/head';
import { createPinia } from 'pinia';

import { router } from '@/routes/index.js';
import { store } from '@/state/store.js';
import { focus } from '@/directives/focus-element.js';
import { TokenPlugin } from '@/utils/csrf-token.js';
import { registerGlobalComponents } from '@/utils/globals.js';
import App from '@/App.vue';

// Check for data from the server and add it to the app component
const root = document.getElementById('app');
const rootName = root.dataset.component || null;
const rootProps = root.dataset.props ? JSON.parse(root.dataset.props) : {};
// ************ end server-side app / client-side view ****************

const app = createApp(App, {
  rootName,
  rootProps,
});

const head = createHead();
const pinia = createPinia();

// Add in global directives
app.directive('focus', focus);

// Add Vue plugins
app.use(TokenPlugin);
// deprecated vuex store
app.use(store);
// now using pinia as the current store
app.use(pinia);
app.use(router);
app.use(head);

registerGlobalComponents(app);

// ************ server-side app / client-side view (https://reinink.ca/articles/server-side-apps-with-client-side-rendering) ****************
// TODO: replace this with InertiaJS which is the framework the came from the above article
// Register Vue components used with laravel routing
app.component(
  'Login',
  defineAsyncComponent(() => import(/* webpackChunkName: "auth" */ '@/views/auth/login.vue'))
);
app.component(
  'Register',
  defineAsyncComponent(() => import(/* webpackChunkName: "signup" */ '@/views/auth/register.vue'))
);
app.component(
  'PasswordResetRequest',
  defineAsyncComponent(() => import(/* webpackChunkName: "password" */ '@/views/auth/password-reset-request.vue'))
);
app.component(
  'PasswordReset',
  defineAsyncComponent(() => import(/* webpackChunkName: "password" */ '@/views/auth/password-reset.vue'))
);
app.component(
  'InvitationExpired',
  defineAsyncComponent(() => import(/* webpackChunkName: "invitation" */ '@/views/auth/invitation-expired.vue'))
);
app.component(
  'InvitationLanding',
  defineAsyncComponent(() => import(/* webpackChunkName: "invitation" */ '@/views/auth/invitation-landing.vue'))
);
// ************ end server-side app / client-side view ****************

// Create the root instance
app.mount('#app');
